import get from 'get-value';
import {sparePartsWebsocketCommands} from '../../constants/sparePartsWebsocketCommands';

export const orderExportTickets = (state = {
    isLoadingExport: false,
    exportRecord: {},
    correlationId: null,
}, action) => {
    switch (action.type) {
        case sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_EXPORT_GET: {
            return Object.assign({}, state, { isLoadingExport: true });
        }
        case sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_EXPORT_SEND: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            const exportRecord = get(action, 'payload.exportRecord', { default: {} });
            return Object.assign({}, state, {
                isLoadingExport: false,
                exportRecord,
                correlationId,
            });
        }
        case sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_EXPORT_SEND_ERROR: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, { isLoadingExport: false });
        }
        case sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_EXPORT_CREATE: {
            const exportRecord = {
                created: new Date(),
                status: 'NEW'
            };
            return Object.assign({}, state, { exportRecord });
        }
        case sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_EXPORT_STATUS:
        case sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_EXPORT_ERROR: {
            const {correlationId, exportRecord} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, { exportRecord, correlationId });
        }
        default:
            return state;
    }
};
